module.controller('addBankSidebarCtrl', ['$scope', function ($scope){
  $scope.title = 'Please Note';
  $scope.info = 'You may only link bank accounts that are in your own name. ' +
    'Linking 3rd party bank accounts may result in your ' + $scope.brand.commonProgramName + ' being suspended.';
  $scope.info2 = 'If you would like to link your company\'s business account, you will be required to ' +
    'send proof of authorization and a current bank statement. Please contact our customer service for more information: ' + $scope.brand.programContactPhone + '.';
}]);
